<template>
  <form
    action=""
    @submit.prevent="onSubmit"
  >
    <div
      :class="$style['inner']"
      class="gray-background-inner input-box"
    >
      <div :class="$style['left-column']">
        <ds-input
          v-model="address"
          :validate-rules="{required: true}"
          :placeholder="placeholder"
          name="ip_address"
          class="ping-inp"
        />
      </div>
      <div>
        <ds-button class="column">{{ buttonText }}</ds-button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: "TracerouteForm",
  props: {
    buttonText: {
      type: String,
      default: "START"
    },
    placeholder: {
      type: String,
      default: "Adres IP lub domena"
    }
  },
  data() {
    return {
      address: ""
    };
  },
  methods: {
    onSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit("onSubmit", this.address);
        }
      });
    }
  }
};
</script>

<style lang="scss">
.ping-inp {
  span {
    display: none;
  }
}
</style>

<style lang="scss" module>
@import "~@theme/scss/_variables.scss";

.left-column {
  width: 100%;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/app/dashboard/forms/domain-form.vue